import React from 'react';

export default function Nodatacomponent({ text }) {
  return (
    <div
      style={{ width: '100%', height: '100%', display:"flex", justifyContent:"center",alignItems:"center" }}
      className="mx-auto d-flex flex-column align-items-center justify-content-center"
    >
      <img
        src="/manage/images/SVG/nodata_image.svg"
        alt="error"
      />
      <span className="Title-small">{text ? text : 'No records found'}</span>
    </div>
  );
}
